(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');

    // directive for quick sidebar task item
    module.directive('autoRefreshToggle', 
        ['$rootScope', 'QuickSidebarTasksService', function ($rootScope, QuickSidebarTasksService) {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/ringfoon/templates/auto-refresh-toggle.template.html',
            scope: {
            },
            link: link

        };
        return directive;

        function link(scope, element) {
            scope.showAutoRefreshToggle = $rootScope.isRingfoonOperatorAdmin || $rootScope.isRingfoonAdmin;
            scope.autoRefresh = true;
            scope.toggle = function() {
                scope.autoRefresh = !scope.autoRefresh;
                QuickSidebarTasksService.data.autoRefreshTasksIsDisabled = !scope.autoRefresh;
                $rootScope.$broadcast(QuickSidebarTasksService.Broadcast.AutoRefreshToggleChanged);
            }

            // destroy
            scope.$on('$destroy', function () {
            });

        }

    }]);

})();